/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIProductionOrderStatusEnum } from './APIProductionOrderStatusEnum';
import {
    APIProductionOrderStatusEnumFromJSON,
    APIProductionOrderStatusEnumFromJSONTyped,
    APIProductionOrderStatusEnumToJSON,
} from './APIProductionOrderStatusEnum';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProductionOrderRequest
 */
export interface APIProductionOrderRequest {
    /**
     * 
     * @type {Date}
     * @memberof APIProductionOrderRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionOrderRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrderRequest
     */
    customerOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrderRequest
     */
    article: string;
    /**
     * 
     * @type {APIProductionOrderStatusEnum}
     * @memberof APIProductionOrderRequest
     */
    status?: APIProductionOrderStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof APIProductionOrderRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrderRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIProductionOrderRequest
     */
    comment?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIProductionOrderRequest
     */
    planning?: APIPlanningEnum | null;
    /**
     * 
     * @type {number}
     * @memberof APIProductionOrderRequest
     */
    priority?: number | null;
}



/**
 * Check if a given object implements the APIProductionOrderRequest interface.
 */
export function instanceOfAPIProductionOrderRequest(value: object): value is APIProductionOrderRequest {
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIProductionOrderRequestFromJSON(json: any): APIProductionOrderRequest {
    return APIProductionOrderRequestFromJSONTyped(json, false);
}

export function APIProductionOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProductionOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'customerOrder': json['customer_order'] == null ? undefined : json['customer_order'],
        'article': json['article'],
        'status': json['status'] == null ? undefined : APIProductionOrderStatusEnumFromJSON(json['status']),
        'amount': json['amount'],
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'planning': json['planning'] == null ? undefined : APIPlanningEnumFromJSON(json['planning']),
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function APIProductionOrderRequestToJSON(value?: APIProductionOrderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start_date': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'customer_order': value['customerOrder'],
        'article': value['article'],
        'status': APIProductionOrderStatusEnumToJSON(value['status']),
        'amount': value['amount'],
        'description': value['description'],
        'comment': value['comment'],
        'planning': APIPlanningEnumToJSON(value['planning']),
        'priority': value['priority'],
    };
}

